import {HStack} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

import PopoverInfo from "../PopoverInfo";
import Text from "../Text";

export type Props = {
    label?: string;
    size?: "xs" | "sm";
    children?: React.ReactNode;
    tooltip?: React.ReactNode;
};

const Label: React.FC<Props> = ({label, tooltip, size = "sm", children}) => {
    return (
        <HStack className="flex flex-row justify-start items-center mb-1 mt-0">
            {(label || typeof children === "string") && (
                <Text color="blueGray.400" numberOfLines={1} variant={size}>
                    {label || children}
                </Text>
            )}
            {children && typeof children !== "string" && children}
            {tooltip && (
                <>
                    &nbsp;
                    <PopoverInfo label={tooltip} />
                </>
            )}
        </HStack>
    );
};

export default memo(Label);
